"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const login_1 = require("@/api/login");
const store_1 = require("@/store");
const car_1 = require("@/api/car");
let Login = class Login extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.form = {
            email: '',
            password: ''
        };
        this.forgetForm = {
            email: '',
            vcode: '',
            newPassword: ''
        };
        this.content = this.$t('获取验证码');
        this.totaltime = 60;
        this.canclick = true;
        this.dialogVisible = false;
    }
    validEmail(email) {
        const reg = /^([\S])+[@]{1}([\S])+[.]{1}(\S)+$/;
        return reg.test(email);
    }
    // 验证码
    getVCode() {
        // getQrCode()  /customerContacts/sendMailCode
        if (this.forgetForm.email) {
            if (!this.validEmail(this.forgetForm.email)) {
                this.$notify.error({ title: 'System error', message: 'Email format error!' });
                return;
            }
            const f = {
                content: this.forgetForm.email
            };
            login_1.getEmailVcode(f).then((res) => {
                this.canclick = false;
                let clock = window.setInterval(() => {
                    this.totaltime--;
                    this.content = this.totaltime + 's';
                    if (this.totaltime < 0) {
                        window.clearInterval(clock);
                        this.content = this.$t('获取验证码');
                        this.totaltime = 60;
                        this.canclick = true; //这里重新开启
                    }
                }, 1000);
                this.$notify.success(res);
            });
        }
        else {
            this.$notify.error('Email is empty');
        }
    }
    toHome() {
        this.$router.push('/home');
    }
    getList(a) {
        let req = {
            loginToken: a.loginToken || '',
            pageNo: 1,
            pageSize: 100,
            content: ''
        };
        car_1.carList(req).then(res => {
            localStorage.setItem('carNum', res.list.length);
            this.setCarNum(res.list.length);
        });
    }
    onLogin() {
        this.$refs.form.validate((valid) => {
            if (valid) {
                login_1.goLogin(this.form).then((res) => {
                    localStorage.setItem('userInfo', JSON.stringify(res));
                    this.setUserInfo(res);
                    this.getList(res);
                    this.$router.push('/home');
                });
            }
        });
    }
    // 忘记密码
    forgetPwd() {
        this.$router.push('/forgetPwd');
    }
    resetPassword() {
        if (!this.forgetForm.vcode) {
            this.$notify.error('Vcode error!');
            return;
        }
        if (!this.forgetForm.newPassword) {
            this.$notify.error('Password error!');
            return;
        }
        if (this.forgetForm.email) {
            if (!this.validEmail(this.forgetForm.email)) {
                this.$notify.error('Email format error!');
                return;
            }
            login_1.resetPassword(this.forgetForm).then((res) => {
                this.$notify.success(res);
                this.dialogVisible = false;
            });
        }
        else {
            this.$notify.error('Email is empty');
        }
    }
    // 注册
    register() {
        this.$router.push('/register');
    }
};
__decorate([
    store_1.AppModule.Mutation
], Login.prototype, "setUserInfo", void 0);
__decorate([
    store_1.AppModule.Mutation
], Login.prototype, "setCarNum", void 0);
Login = __decorate([
    vue_property_decorator_1.Component
], Login);
exports.default = Login;
